import { useMutation } from "@tanstack/react-query";

import { logout, requestOtp, verifyOtp } from "./auth";
import type { AuthResponse, RequestOtpPayload, VerifyOtpPayload, VerifyOtpResponse } from "./type";

export function useRequestOtpApi() {
  return useMutation<AuthResponse, Error, RequestOtpPayload>({
    mutationFn: requestOtp,
  });
}

export function useVerifyOtpApi() {
  return useMutation<VerifyOtpResponse, Error, VerifyOtpPayload>({
    mutationFn: verifyOtp,
  });
}

export function useLogoutApi() {
  return useMutation<AuthResponse, Error, void>({
    mutationFn: logout,
  });
}
